<section class="widget-element widget-summary" [class.loading]="loading">

  @if (loading) {
    <div class="widget-element-loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }

  <div class="widget-element-header widget-summary-header">
    <h1 class="widget-element-title widget-summary-user">
      Welcome
      @if (userFirstName) {
        {{ userFirstName }}
        {{ userLastName }}
      }
    </h1>

    @if (userTitle) {
      <div class="contact-title">
        {{ userTitle }}
      </div>
    }
    @if (userPhone || userEmail) {
      <div class="contact-info">
        @if (userPhone) {
          {{ userPhone | phoneNumber: 'US' }} |
        }
        {{ userEmail }}
      </div>
    }
  </div>

  @if (!loading && userAccountName) {
    <div class="widget-element-content widget-summary-content">
      <div class="billing-address">
        <div class="company-title">
          {{ userAccountName }}
        </div>
        <div class="address-label">
          Billing Address
        </div>
        <div class="address-content">
          <div class="custom-icon location_dark">
            location icon
          </div>
          <pre>{{ userBillingAddress }}</pre>
        </div>
      </div>
    </div>
  }

</section>